import type { CostFileTemplateState } from './CostFileTemplate.types';

export const INIT_STATE: CostFileTemplateState = {
  data: [],
  pagination: {
    sort: {
      field: 'updated',
      order: 'DESC',
    },
    results_per_page: 10,
    total: 0,
  },
  adPartners: new Map(),
  lastUpdated: undefined,
};
